angular
	.module 'App.Repository'
	.factory 'ProductImagesRepository', ['BaseRepository', (BaseRepository) ->
		class ProductImagesRepository extends BaseRepository
			@resource = '/product_images'
			@isRestricted = true

		return new ProductImagesRepository
	]
